import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';

import { getParameterByName } from '../../utils/utils';
import RegisterSnackBar from './components/RegisterSnackBar'
import {
    Grid,
    TextField,
    Link,
    Typography
} from '@material-ui/core';

import { HORIZONTAL_LOGO as theLogo } from '../../constants';
import SignInButton from '../SignIn/SignInButton'

import '../SignUp/css/style.css'
import LoadingIndicator from '../../components/LoadingIndicator';

const schema = {
    code: {
        presence: { allowEmpty: false, message: 'is required' },
        email: false,
        length: {
            minimum: 4,
            maximum: 8
        }
    },
   
};

makeStyles(theme => {
    console.log(theme)
});

const useStyles = makeStyles(theme => ({
    root: {
    },
    grid: {
        height: '100%'
    },
    quoteContainer: {
    },
    quote: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    },
    quoteInner: {
        textAlign: 'center',
        flexBasis: '600px'
    },
    quoteText: {
        color: 'white',
        fontWeight: 300
    },
    name: {
        marginTop: '8px',
        color: 'white'
    },
    bio: {
        color: 'white'
    },
    contentContainer: {},
    content: {

        flexDirection: 'column'
    },
    panelSpacer: {
        width: 1,
        height: '15vh',
        minHeight: 208,
    },
    contentHeader: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '8px',
        paddingBototm: '8px',
        paddingLeft: '8px',
        paddingRight: '8px'
    },
    logoImage: {
        marginLeft: '16px'
    },
    contentBody: {
        flexGrow: 1,
        // display: 'flex', 
        width: '60vw',
        minWidth: 320,
        // maxWidth: 470,

    },
    form: {
        // borderColor: '#00BFFF',
        // borderStyle: 'solid',
        // borderWidth: 'medium',
        borderRadius: '8px',
        position: 'relative',
        top: '40%',
        textAlign: 'center',
        alignItems: 'center',
        paddingTop: 32,
        paddingLeft: '10%',
        paddingRight: '10%',
        paddingBottom: 48,
        maxWidth: 470,
        margin: 'auto',

        // [theme.breakpoints.down('sm')]: {
        //     paddingLeft: '8px',
        //     paddingRight: '8px'
        // },
        // background: '#fff'
    },
    title: {
        marginTop: '8px'
    },
    socialButtons: {
        marginTop: '8px'
    },
    socialIcon: {
        marginRight: '4px'
    },
    suggestion: {
        marginTop: '8px'
    },
    textField: {
        marginTop: '8px',
    },
    overrides: {
        // Style sheet name ⚛️
        MuiButton: {
            // Name of the rule
            text: {
                // Some CSS
                color: 'white',
            },
        },
    },
}));

const SignUpVerification = props => {
    const { history, updateUser, apiManager, appProps } = props;
    const signOutNow = getParameterByName('signout') || false;
    const [init, setInit] = React.useState(false);
    const [email, setEmail] = React.useState(localStorage.getItem('uid'));
    const [password, setPassword] = React.useState(localStorage.getItem('pid'));
    const [hasCode, setHasCode] = React.useState(false);

    const classes = useStyles();

    const [formState, setFormState] = useState({
        isValid: false,
        values: {},
        touched: {},
        errors: {},
        isSuccessfull: false,
        isModalOpen: false,
        snackMessage: '',
    });

        const signOut = async () => {
        await apiManager.signOut();
    }

    if (!init && signOutNow && signOutNow === 'true') {
        setInit(true);
        signOut();
        appProps.userHasAuthenticated(false);
        history.push('/signin');

    }


    const handleCodeParameter = async (code) => {
        if (code) {
            try {

                const result = await apiManager.validateCode(email, code, password);
                appProps.userHasAuthenticated(true);

                if (result && result.signedIn && result.signedIn === true) {
                    setFormState(formState => ({
                        ...formState,
                        isSuccessfull: true,
                        isModalOpen: true,
                        snackMessage: "Sign In Successfull"
                    }));
                    // updateUser(result.data);
                    // localStorage.setItem('token', result.data.token);
                    history.push('/');
                }
                else {

                    setFormState(formState => ({
                        ...formState,
                        error: 'Invalid code',
                        isSuccessfull: false,
                        isModalOpen: true,
                        snackMessage: result.message
                    }));
                   //  setHasCode(false);
                    //updateUser({ name: 'test-user' });
                    //history.push('/dashboard');
                }
            }
            catch (ex) {
                console.log(ex);
               // setHasCode(false);
                if (ex.code === 'UserNotConfirmedException') {
                    alert('go to confirmation page')
                } else {
                    setFormState(formState => ({
                        ...formState,
                        error: ex.message,
                        isSuccessfull: false,
                        isModalOpen: true,
                        // snackMessage: ex.message.replace(/Username/i, 'Verification Code'),
                        snackMessage: 'Verification code is required.'
                    }));
                }
            }

        };
    }


    let urlCode = false;
    if (!init) {
        setInit(true);
        setTimeout(() => {
            const scrollToElement = document.getElementById('content-top');
            if (scrollToElement) {
                scrollToElement.scrollIntoView({ behavior: 'smooth' });
            }
        }, 250);

        urlCode = getParameterByName('c');
        if( urlCode ) {
            setHasCode(true);
            handleCodeParameter(urlCode);
        }
    }


    useEffect(() => {
        const errors = validate(formState.values, schema);

        setFormState(formState => ({
            ...formState,
            isValid: errors ? false : true,
            errors: errors || {}
        }));
    }, [formState.values]);

    const handleChange = event => {
        event.persist();

        setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]:
                    event.target.type === 'checkbox'
                        ? event.target.checked
                        : event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true
            }
        }));
    };

    const resendCode = async event => {
        const result = await apiManager.resendCode(email);
        let message = result;
        if (result === 'resent') {
            message = 'A new code has been sent to your email'
        }
        setFormState(formState => ({
            ...formState,
            isSuccessfull: result === 'resent',
            isModalOpen: true,
            snackMessage: message,
        }));
    }

    const handleCodeSubmit = async event => {
        event.preventDefault();
        setFormState(formState => ({
            ...formState,
            error: ''
        }));
        
        const { code } = formState.values;

        try {

            const result = await apiManager.validateCode(email, code, password);
            appProps.userHasAuthenticated(true);

            if (result && result.signedIn && result.signedIn === true) {
                setFormState(formState => ({
                    ...formState,
                    isSuccessfull: true,
                    isModalOpen: true,
                    snackMessage: "Sign In Successfull"
                }));
                // updateUser(result.data);
                // localStorage.setItem('token', result.data.token);
                history.push('/');
            }
            else {
                
                setFormState(formState => ({
                    ...formState,
                    error: 'Incorrect user name and/or password',
                    isSuccessfull: false,
                    isModalOpen: true,
                    snackMessage: result.message
                }));
                //updateUser({ name: 'test-user' });
                //history.push('/dashboard');
            }
        }
        catch (ex) {
            console.log(ex);
            
            if( ex.code === 'UserNotConfirmedException') {
                alert('go to confirmation page')
            } else {
                setFormState(formState => ({
                    ...formState,
                    error: ex.message,
                    isSuccessfull: false,
                    isModalOpen: true,
                    // snackMessage: ex.message.replace(/Username/i, 'Verification Code'),
                    snackMessage: 'Verification code is required.'
                }));
            }
        }

    };

    const forgotPasswordClick = async (event) => {
        event.preventDefault();
    }
    const closeModal = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setFormState(formState => ({
            ...formState,
            isModalOpen: false,
        }));
    }

    const hasError = field =>
        formState.touched[field] && formState.errors[field] ? true : false;
    

    const renderVerificationInProgress = () => {
        return (
            <div style={{fontSize: 18, textAlign: 'center', color: '#594a42', marginTop: 40}}>
            Completing your registration...
            <LoadingIndicator />
            <div><b>PLEASE NOTE:</b> You may need to check your spam folder for the registration confirmation email.</div>
            </div>
        )
    }

    const renderForm = () => {
        return (
            <>
                <Typography
                    className={classes.title}
                    // variant="h6"
                    align="center"
                >
                    <img src={theLogo} alt="Soil Health Academy.com" width="200px" align='middle' style={{ marginBottom: 48 }} />
                    <div style={{ fontSize: 18, textAlign: 'center', color: '#594a42' }}>
                        <p><b>
                            We have sent a confirmation email to {email}.
                            </b></p>
                        <p>
                            Please click on the link in the email to complete your registration<br />
                            or copy the code from the email to the form below.
                            </p>
                        <p>
                            If you don't see the email in your inbox, please be sure to check your spam/junk folder
                            </p>
                        <br />
                    </div>
                    <h4 style={{ color: '#594a42' }}>Please enter the verification code<br />sent to your email address:</h4>

                </Typography>
                <form
                    className={classes.form}
                    onSubmit={handleCodeSubmit}
                >
                    <TextField
                        className={classes.textField}
                        error={hasError('code')}
                        fullWidth
                        helperText={
                            hasError('code') ? formState.errors.code[0] : null
                        }
                        label="Verification Code"
                        name="code"
                        onChange={handleChange}
                        type="text"
                        value={formState.values.code || ''}
                        variant="standard"
                    />


                    <div style={{ textAlign: 'center', marginTop: 24 }}>
                        <RegisterSnackBar isOpen={formState.isModalOpen} isSuccessfull={formState.isSuccessfull} message={formState.snackMessage} closeModal={closeModal} />
                        <SignInButton cta='Continue' handleSignIn={handleCodeSubmit} disabled={false} />

                    </div>
                    <div style={{ 'textAlign': 'center', marginTop: '20px' }}> Need a new code?
                                <Link href="#"
                            onClick={resendCode}>
                            {" "}Send New Code <br /><br />
                            <span><b>NOTE:</b> You may need to check your spam folder for the code email</span>
                        </Link>

                    </div>
                </form>
            </>
        )
    }

    return (

        <div id="content-top" className={classes.root}>
            <Grid
                className={classes.content}
                item
                lg={12}
                me={12}
                sm={12}
                xs={12}
                alignItems="center"
                container
            >
                <div className={classes.content}>
                    <div className={classes.panelSpacer} />
                    <div className={classes.contentBody}>
                        {/* {(hasCode || urlCode) 
                        ? renderVerificationInProgress()
                        : renderForm()
                        } */}
                           <LoadingIndicator />
                    </div>
                </div>
            </Grid>
        </div>
    );
};

SignUpVerification.propTypes = {
    history: PropTypes.object,
    updateUser: PropTypes.func
};

export default withRouter(SignUpVerification);
